import "../../../assets/css/navVerical.css";
import "../../../assets/css/responsive_navVertical.css";
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PeopleIcon from "@mui/icons-material/People";
import ListAltIcon from '@mui/icons-material/ListAlt';

import ContactlessIcon from "@mui/icons-material/Contactless";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LanguageIcon from "@mui/icons-material/Language";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ViewListIcon from "@mui/icons-material/ViewList";
import StoreIcon from "@mui/icons-material/Store";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import SendIcon from "@mui/icons-material/Send";
import InventoryIcon from "@mui/icons-material/Inventory";
import { PersonAdd } from "@mui/icons-material";
import EventIcon from '@mui/icons-material/Event';

import logoKertys from "../../img/logoKertys.png";
import NavBar from "../../service_navBar/navBar";
import { get_company_logo } from "../../../services/for_allServices";
import { useAuth } from "../../../contexts/AuthContext";

function Responsive_navVertical({
  company_nav_logo,
  logout,
  nav_color,
  Component,
  menu_color,
}) {
  function show_sideBar(menu_sm) {
    var sidebar = menu_sm.nextSibling;
    let service_menu_holder = document.getElementById("service_menu_holder");
    if (sidebar && sidebar.className.includes("responsive_service_content")) {
      menu_sm.classList.toggle("open");
      sidebar.classList.toggle("show");
    }
  }

  function close_sidebar() {
    let menu_sm = document.getElementById("service_menu_holder");
    let sidebar = menu_sm.nextSibling;
    if (sidebar && sidebar.className.includes("responsive_service_content")) {
      menu_sm.classList.remove("open");
      sidebar.classList.remove("show");
    }
  }

  return (
    <>
      <div className="responsive_navVertical">
        <div
          id="service_menu_holder"
          onClick={(event) => show_sideBar(event.target)}
          style={{ background: menu_color }}
        >
          <div
            onClick={(event) => show_sideBar(event.target.parentNode)}
            style={{ background: nav_color }}
          ></div>
          <div
            onClick={(event) => show_sideBar(event.target.parentNode)}
            style={{ background: nav_color }}
          ></div>
          <div
            onClick={(event) => show_sideBar(event.target.parentNode)}
            style={{ background: nav_color }}
          ></div>
        </div>
        <div
          className="responsive_service_content"
          style={{ background: nav_color }}
        >
          <Link
            className="company_nav_logo_container"
            onTouchEnd={close_sidebar}
            to="/serviceAchat"
          >
            {company_nav_logo !== null ? (
              <>
                <img
                  src={
                    company_nav_logo !== ""
                      ? `data:image/*;base64,${company_nav_logo}`
                      : logoKertys
                  }
                />
              </>
            ) : (
              <></>
            )}
          </Link>

          <div className="menu_items">
            <div>
              <Link
                to="/serviceAchat/tableauDeBord"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/tableauDeBord"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <DashboardIcon />{" "}
                  <span className="title_menu_item">Tableau de bord</span>
                </div>
              </Link>
              <Link
                to="/serviceAchat/Fiche_Identite"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/Fiche_Identite"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <AccountCircleIcon />{" "}
                  <span className="title_menu_item">Fiche d'identité</span>
                </div>
              </Link>
              <Link
                to="/serviceAchat/Referencements"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/Referencements"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <PeopleIcon />{" "}
                  <span className="title_menu_item"> Referencements </span>
                </div>
              </Link>
              <Link
                to="/serviceAchat/AjouterFournisseur"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname ===
                    "/serviceAchat/AjouterFournisseur"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <PersonAdd />{" "}
                  <span className="title_menu_item">
                    Ajouter un fournisseur
                  </span>{" "}
                </div>
              </Link>
              {/* <Link
                to="/serviceAchat/suppliers"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/suppliers"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <PeopleOutlineIcon />{" "}
                  <span className="title_menu_item"> Fournisseurs </span>
                </div>
              </Link> */}
              <Link
                to="/serviceAchat/mesAppelsOffres"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/mesAppelsOffres"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <LocalOfferIcon />{" "}
                  <span className="title_menu_item">Appels d'offre</span>{" "}
                </div>
              </Link>
              <Link
                to="/serviceAchat/soumissions"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/soumissions"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <ViewListIcon />{" "}
                  <span className="title_menu_item">Soumissions</span>{" "}
                </div>
              </Link>
              <Link
                to="/serviceAchat/commissions"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/commissions"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <FormatListBulletedIcon />{" "}
                  <span className="title_menu_item">Commissions</span>{" "}
                </div>
              </Link>
              <Link
                to="/serviceAchat/contrats"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/contrats"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <ContentCopyIcon />{" "}
                  <span className="title_menu_item">Contrats</span>{" "}
                </div>
              </Link>
              <Link
                to="/serviceAchat/facture"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/facture"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <ContactlessIcon />{" "}
                  <span className="title_menu_item">Factures / Paiements</span>{" "}
                </div>
              </Link>
              <Link
                className={
                  window.location.pathname === "/serviceAchat/demande_achat"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
                onTouchEnd={close_sidebar}
                to="/serviceAchat/demande_achat"
              >
                <div>
                  <StoreIcon />
                  <span className="title_menu_item">
                    Ajouter une demande d'achat{" "}
                  </span>{" "}
                </div>
              </Link>
              <Link
                to="/serviceAchat/demandes"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/demandes"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <RequestPageIcon />{" "}
                  <span className="title_menu_item">Demandes d'achats</span>{" "}
                </div>
              </Link>


              <Link
                to="/serviceAchat/projets"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/projets"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <EventIcon />{" "}
                  <span className="title_menu_item">Projets</span>{" "}
                </div>
              </Link>
              <Link
                to="/serviceAchat/catalogue"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/catalogue"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <ListAltIcon />{" "}
                  <span className="title_menu_item">Catalogue</span>{" "}
                </div>
              </Link>
              {/* <Link
                to="/serviceAchat/famille_achat"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/famille_achat"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <FormatListBulletedIcon />{" "}
                  <span className="title_menu_item">Familles d'achat</span>{" "}
                </div>
              </Link> */}
              <Link
                to="/serviceAchat/stock"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/stock"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <InventoryIcon />{" "}
                  <span className="title_menu_item">Stock</span>{" "}
                </div>
              </Link>
              <Link
                to="/serviceAchat/envoyer_email"
                onTouchEnd={close_sidebar}
                className={
                  window.location.pathname === "/serviceAchat/envoyer_email"
                    ? "menu_item menu_item_selected"
                    : "menu_item"
                }
              >
                <div>
                  <SendIcon />{" "}
                  <span className="title_menu_item">Envoyer un email</span>{" "}
                </div>
              </Link>
              {/* <div className={window.location.pathname==="/serviceAchat/litiges"?"menu_item menu_item_selected":"menu_item"} to="/serviceAchat/litiges"}>
                      <div><AnnouncementIcon /> <span className="title_menu_item">Litiges </span> </div>
                    </div> */}
              {/* <div className="menu_item" onClick={() => window.location.href="https://www.kertys.com"}>
                      <div><LanguageIcon/><span className="title_menu_item"> https://www.kertys.com</span> </div>
                    </div> */}
            </div>

            <div className="menu-connection">
              <div className="menu_item" onClick={logout}>
                <div>
                  <ExitToAppIcon />{" "}
                  <span className="title_menu_item">Logout</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="responsive_service_body">
        {Component ? (
          <>
            <Component />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

function NavVertical({ Component }) {
  const { logout } = useAuth();
  let history = useHistory();
  let user = JSON.parse(localStorage.getItem("user-info"));

  const [responsive_menu, setResponsive_menu] = useState(null);

  const [company_nav_logo, setcompany_nav_logo] = useState(null);
  const [company_logo, setcompany_logo] = useState(null);

  const [nav_color, setNav_color] = useState("");
  const [menu_color, setMenu_color] = useState("");

  useEffect(() => {
    async function check_width() {
      if (window.innerWidth > 1010) {
        setResponsive_menu(false);
      } else {
        setResponsive_menu(true);
      }
    }

    async function load_data() {
      await check_width();
      await setNav_color(user.company_color.split(",")[0]);
      await setMenu_color(user.company_color.split(",")[1]);
      await get_company_logo()
        .then((response) => {
          setcompany_nav_logo(response.data.company_nav_logo);
          setcompany_logo(response.data.company_logo);
        })
        .catch((error) => {
          //console.log(error.response);
        });
    }
    load_data();
  }, []);

  const load_component = React.useMemo(() => {
    return (
      <>
        {Component ? (
          <>
            <Component />
          </>
        ) : (
          <></>
        )}
      </>
    );
  }, [Component]);

  return (
    <>
      {responsive_menu != null ? (
        <>
          <NavBar menu_color={menu_color} company_logo={company_logo} />
          <div className="nav_menu_container">
            {responsive_menu !== true ? (
              <>
                <div
                  className="service_content show"
                  style={{ background: nav_color }}
                >
                  <Link
                    className="company_nav_logo_container"
                    to="/serviceAchat"
                  >
                    {company_nav_logo !== null ? (
                      <>
                        <img
                          src={
                            company_nav_logo !== ""
                              ? `data:image/*;base64,${company_nav_logo}`
                              : logoKertys
                          }
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </Link>

                  <div className="menu_items">
                    <div>
                      <Tooltip title="Tableau de bord" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/tableauDeBord"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/tableauDeBord"
                        >
                          <div>
                            <DashboardIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Fiche d'identité" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/Fiche_Identite"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/Fiche_Identite"
                        >
                          <div>
                            <AccountCircleIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Referencements" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/Referencements"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/Referencements"
                        >
                          <div>
                            <PeopleIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip
                        title="Ajouter un fournisseur"
                        placement="right"
                        arrow
                      >
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/AjouterFournisseur"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/AjouterFournisseur"
                        >
                          <div>
                            <PersonAdd />
                          </div>
                        </Link>
                      </Tooltip>
                      {/* <Tooltip title="Fournisseurs" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/suppliers"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/suppliers"
                        >
                          <div>
                            <PeopleOutlineIcon />
                          </div>
                        </Link>
                      </Tooltip> */}
                      <Tooltip title="Appels d'offre" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                            "/serviceAchat/mesAppelsOffres"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/mesAppelsOffres"
                        >
                          <div>
                            <LocalOfferIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Soumissions" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                            "/serviceAchat/soumissions"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/soumissions"
                        >
                          <div>
                            <ViewListIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Commissions" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                            "/serviceAchat/commissions"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/commissions"
                        >
                          <div>
                            <FormatListBulletedIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Contrats" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/contrats"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/contrats"
                        >
                          <div>
                            <ContentCopyIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip
                        title="Factures / Paiements"
                        placement="right"
                        arrow
                      >
                        <Link
                          className={
                            window.location.pathname === "/serviceAchat/facture"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/facture"
                        >
                          <div>
                            <ContactlessIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip
                        title="Ajouter une demande d'achat "
                        placement="right"
                        arrow
                      >
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/demande_achat"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/demande_achat"
                        >
                          <div>
                            <StoreIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip
                        title="Demandes d'achats"
                        placement="right"
                        arrow
                      >
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/demandes"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/demandes"
                        >
                          <div>
                            <RequestPageIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip
                        title="Projets"
                        placement="right"
                        arrow
                      >
                        <Link
                          className={
                            window.location.pathname === "/serviceAchat/projets"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/projets"
                        >
                          <div>
                            <EventIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Catalogue" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname === "/serviceAchat/catalogue"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/catalogue"
                        >
                          <div>
                            <ListAltIcon />
                          </div>
                        </Link>
                      </Tooltip>
                     {/*  <Tooltip title="Familles d'achat" placement="right" arrow>
                        <Link className={window.location.pathname === "/serviceAchat/famille_achat" ? "menu_item menu_item_selected" : "menu_item"} to="/serviceAchat/famille_achat">
                          <div><FormatListBulletedIcon /></div>
                        </Link>
                      </Tooltip> */}
                      <Tooltip title="Stock" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname === "/serviceAchat/stock"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/stock"
                        >
                          <div>
                            <InventoryIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Envoyer un email" placement="right" arrow>
                        <Link
                          className={
                            window.location.pathname ===
                              "/serviceAchat/envoyer_email"
                              ? "menu_item menu_item_selected"
                              : "menu_item"
                          }
                          to="/serviceAchat/envoyer_email"
                        >
                          <div>
                            <SendIcon />
                          </div>
                        </Link>
                      </Tooltip>
                      {/* <Tooltip title="Litiges" placement="right" arrow>
                  <Link className={window.location.pathname==="/serviceAchat/litiges"?"menu_item menu_item_selected":"menu_item"} to="/serviceAchat/litiges"}>
                    <div><AnnouncementIcon /></div>
                  </div>
                </Tooltip> */}
                      {/* <Tooltip title="https://www.kertys.com" placement="right" arrow>
                  <div className="menu_item" onClick={() => window.location.href="https://www.kertys.com"}>
                    <div><LanguageIcon/></div>
                  </div>
                </Tooltip> */}
                    </div>

                    <div className="menu-connection">
                      <Tooltip title="Logout" placement="right" arrow>
                        <div className="menu_item" onClick={logout}>
                          <div>
                            <ExitToAppIcon />
                          </div>
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div className="service_body">{load_component}</div>
              </>
            ) : (
              <Responsive_navVertical
                company_nav_logo={company_nav_logo}
                logout={logout}
                nav_color={nav_color}
                Component={Component}
                menu_color={menu_color}
              />
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default NavVertical;

/*

  <Tooltip title="Tableau de bord" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/tableauDeBord"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/tableauDeBord"}>
                    <div><DashboardIcon /></div>
                  </div>
                </Tooltip>
                <Tooltip title="Fiche d'identité" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/Fiche_Identite"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/Fiche_Identite"}>
                    <div><AccountCircleIcon/></div>
                  </div>
                </Tooltip>
                <Tooltip title="Referencements" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/Referencements"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/Referencements"}>
                    <div><PeopleIcon/></div>
                  </div>
                </Tooltip>
                <Tooltip title="Ajouter un fournisseur" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/AjouterFournisseur"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/AjouterFournisseur"}>
                    <div><PersonAdd/></div>
                  </div>
                </Tooltip>
                <Tooltip title="Appels d'offre" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/mesAppelsOffres"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/mesAppelsOffres"}>
                    <div><LocalOfferIcon /></div>
                  </div>
                </Tooltip>
                <Tooltip title="Soumissions" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/soumissions"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/soumissions"}>
                    <div><ViewListIcon /></div>
                  </div>
                </Tooltip>
                <Tooltip title="Commissions" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/commissions"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/commissions"}>
                    <div><FormatListBulletedIcon /></div>
                  </div>
                </Tooltip>
                <Tooltip title="Contrats" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/contrats"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/contrats"}>
                    <div><ContentCopyIcon/></div>
                  </div>
                </Tooltip>
                <Tooltip title="Factures / Paiements" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/facture"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/facture"}>
                    <div><ContactlessIcon /></div>
                  </div>
                </Tooltip>
                <Tooltip title="Demandes d'achats" placement="right" arrow>
                  <div className={window.location.pathname==="/serviceAchat/demandes"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/demandes"}>
                    <div><RequestPageIcon /></div>
                  </div>
                </Tooltip>
*/

/*

  <div className={window.location.pathname==="/serviceAchat/tableauDeBord"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/tableauDeBord"}>
                      <div><DashboardIcon /> <span className="title_menu_item" >Tableau de bord</span></div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/Fiche_Identite"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/Fiche_Identite"}>
                      <div><AccountCircleIcon/> <span className="title_menu_item">Fiche d'identité</span></div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/Referencements"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/Referencements"}>
                      <div><PeopleIcon/> <span className="title_menu_item"> Referencements </span></div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/AjouterFournisseur"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/AjouterFournisseur"}>
                      <div><PersonAdd/>  <span className="title_menu_item">Ajouter un fournisseur</span>  </div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/mesAppelsOffres"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/mesAppelsOffres"}>
                      <div><LocalOfferIcon />  <span className="title_menu_item">Appels d'offre</span>  </div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/soumissions"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/soumissions"}>
                      <div><ViewListIcon />  <span className="title_menu_item">Soumissions</span> </div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/commissions"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/commissions"}>
                      <div><FormatListBulletedIcon /> <span className="title_menu_item">Commissions</span> </div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/contrats"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/contrats"}>
                      <div><ContentCopyIcon/> <span className="title_menu_item">Contrats</span> </div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/facture"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/facture"}>
                      <div><ContactlessIcon /> <span className="title_menu_item">Factures / Paiements</span> </div>
                    </div>
                    <div className={window.location.pathname==="/serviceAchat/demandes"?"menu_item menu_item_selected":"menu_item"} onClick={() => window.location.href="/serviceAchat/demandes"}>
                      <div><RequestPageIcon /> <span className="title_menu_item">Demandes d'achats</span> </div>
                    </div>
*/
